import React, { createContext } from 'react';

export const GPSStorelist = createContext();
